import Preloader from '../src/components/Preloader';
import Mainmenu from '../src/components/Mainmenu';
import Banner from '../src/components/Banner';
import Aboutus from '../src/components/Aboutus';
import Steps from '../src/components/Steps';
import Donate from '../src/components/Donate';
import Counter from '../src/components/Counter';
import Apply from '../src/components/Apply';
import Faq from '../src/components/Faq';

function App() {
  return (
    <>
    {/* <Preloader /> */}
    <Mainmenu />
    <Banner />
    <Aboutus />
    <Steps />
    <Donate />
    <Counter />
    <Apply />
    <Faq />
    </>
  );
}

export default App;
